import { ReactElement } from "react";
import styles from "rivals/components/shared/Icons/Icons.module.scss";
import { IconProps } from "rivals/components/shared/Icons/iconPropsTypes";

const AlertArrows = ({
  height = "24px",
  width = "24px",
  fillBg = styles.pass,
  fill = styles.white
}: IconProps): ReactElement => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 16 16"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Symbols">
        <g id="transferred-to">
          <path
            d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
            fill={fillBg}
            id="Oval"
          />
          <g id="icn-/-school">
            <mask
              height="9"
              id="mask0_11908_3029"
              maskUnits="userSpaceOnUse"
              style={{ maskType: "alpha" }}
              width="8"
              x="4"
              y="4"
            >
              <g id="mask-2">
                <path
                  d="M6.12132 7.76078L6.82843 8.46789L5.796 9.49998L10 9.5V10.5L6.0328 10.5L6.82843 11.2963L6.12132 12.0034L4 9.8821L6.12132 7.76078ZM9.87868 4L12 6.12132L9.87868 8.24265L9.17157 7.53554L9.9672 6.7392L6 6.73922V5.73922L10.204 5.7392L9.17157 4.70711L9.87868 4Z"
                  fill="white"
                  id="Vector"
                />
              </g>
            </mask>
            <g mask="url(#mask0_11908_3029)">
              <path
                d="M6.12132 7.76078L6.82843 8.46789L5.796 9.49998L10 9.5V10.5L6.0328 10.5L6.82843 11.2963L6.12132 12.0034L4 9.8821L6.12132 7.76078ZM9.87868 4L12 6.12132L9.87868 8.24265L9.17157 7.53554L9.9672 6.7392L6 6.73922V5.73922L10.204 5.7392L9.17157 4.70711L9.87868 4Z"
                fill={fill}
                id="Combined-Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default AlertArrows;
